import React from 'react';
import { Card } from '../../../../components/Card';
import { FormFieldHeader } from '../../../../components/FormFieldHeader';
import { InfoTooltip } from '../../../../components/InfoTooltip';
import { FieldList } from '../FieldList';
import { SectionHeader } from '../SectionHeader';
import { ClientId, FieldConfig, FieldData } from '../Field';
import { Action } from '../dispatcher';
import { IconButton } from '../../../../components/IconButton';

export interface SectionData {
  /** Server-side ID. Null if the field is not yet persisted. */
  sId: number | null;
  /** Client-side ID. Always filled. */
  cId: ClientId;
  name: string;
  fields: FieldData[];
}

interface PropTypes {
  singleTypeSections: boolean;
  fieldConfig: FieldConfig[];
  data: SectionData;
  dispatch: React.Dispatch<Action>;
  removeDisabled: boolean;
}

export function Section(props: PropTypes) {
  function handleRemove() {
    props.dispatch({ type: 'section_remove', sectionId: props.data.cId });
  }

  function handleUp() {
    props.dispatch({ type: 'section_up', sectionId: props.data.cId });
  }

  function handleDown() {
    props.dispatch({ type: 'section_down', sectionId: props.data.cId });
  }

  function handleTitleChange(event) {
    props.dispatch({
      type: 'section_title_change',
      sectionId: props.data.cId,
      title: event.target.value,
    });
  }

  function handleFieldAdd() {
    props.dispatch({
      type: 'field_add',
      sectionId: props.data.cId,
      copy: props.singleTypeSections,
    });
  }

  return (
    <Card className='border'>
      <SectionHeader
        sectionId={props.data.cId}
        removeDisabled={props.removeDisabled}
        onRemove={handleRemove}
        onUp={handleUp}
        onDown={handleDown}
      />
      <input
        className='mt-3 form-control fs-5'
        style={{ maxWidth: '300px' }}
        placeholder='Insert section title'
        value={props.data.name}
        onChange={handleTitleChange}
      />
      <div className='pt-3 d-flex gap-2'>
        <FormFieldHeader
          classNames='fw-semibold'
          fieldName='Fields'
          isRequired={true}
        />
        {props.singleTypeSections && (
          <InfoTooltip>
            Changing the field type of the first section will automatically
            update all fields.
          </InfoTooltip>
        )}
      </div>
      <FieldList
        sectionId={props.data.cId}
        fields={props.data.fields}
        fieldTypeConfigs={props.fieldConfig}
        dispatch={props.dispatch}
        singleTypeSections={props.singleTypeSections}
      />
      <div className='mt-2'>
        <IconButton
          iconName='bi-plus-circle'
          buttonText='Add Field'
          color='borderless'
          disabled={
            props.singleTypeSections
              ? props.data.fields[0]?.fieldType == null
              : false
          }
          onClick={handleFieldAdd}
        />
      </div>
    </Card>
  );
}
